import React, { Component } from 'react';
import { connect } from 'react-redux';
import { each, values, reduce, trimEnd } from 'lodash';
import PropTypes from 'prop-types';
import { ButtonGroup, Button } from 'react-bootstrap';
import ProgressBar from '../../../../components/progress-bar';
import GodTable, { CUSTOM_FIELD_TYPES } from '../../../../components/god-table';
import { 
  getProgressLoadPercentage,
  getProgressStats,
} from '../../../Dashboard/DashboardReducer';
import { getTablePreference } from '../../../App/AppReducer';
import SaleRepsNameRenderer from '../../../../components/table-cells/SaleRepsNameRenderer';
import NumberRenderer from '../../../../components/table-cells//NumberRenderer';

import NumberDisplay from '../../../../components/number-display';
import Counter from '../../../../components/counter';

const TABLE_NAME = 'progress-owner-table';


class OwnerTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullScreenMode: false,
      viewType: null,
    };
    this.getColDefs = this.getColDefs.bind(this);
    this.onExitFullScreen = this.onExitFullScreen.bind(this);
    this.onEnterFullScreen = this.onEnterFullScreen.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.onToggleViewType = this.onToggleViewType.bind(this);
    this.columnPercentValueGetter = this.columnPercentValueGetter.bind(this);
  }

  
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onExitFullScreen() {
    this.setState({ fullScreenMode: false });
    this.props.onExitFullScreen();
  }

  onEnterFullScreen() {
    this.setState({ fullScreenMode: true });
  }

  onToggleViewType(viewType) {
    this.setState({ viewType });
  }

  getSalesRepColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: 'name',
      enableRowGroup: true,
      enablePivot: true,
      cellRenderer: SaleRepsNameRenderer,
      keyCreator: (params) => {
        const vals = params.value;
        if (!vals || (vals && vals.length === 0)) {
          return '--';
        }
        return vals;
      },
      cellRendererParams: {
        column,
        displayStatus: true,
        isOwner: true,
      },
    };
  }

  getStatColumn(column) {
    const onClick = (data) => {
      const ids = data[column.tag]?.ids;
      if (ids && ids.length) {
        this.props.showStats(ids);
      }
    };
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      field: `${column.tag}.count`,
      type: 'numericColumn',
      cellRenderer: NumberRenderer,
      cellRendererParams: {
        column,
        precision: 0,
        onClick,
      },
    };
  }

  getStatPercentColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      width: column.width,
      hide: !column.is_visible,
      type: 'numericColumn',
      cellRenderer: NumberRenderer,
      valueGetter: this.columnPercentValueGetter,
      cellRendererParams: {
        column,
        precision: 2,
        suffix: '%',
      },
    };
  }

  getRemindersColumn(column) {
    return {
      colId: column._id,
      headerName: column.label,
      field: 'reminders.count',
      width: column.width,
      hide: !column.is_visible,
      type: 'numericColumn',
      cellRenderer: NumberRenderer,
      cellRendererParams: {
        column,
        precision: 0,
      },
    };
  }

  columnPercentValueGetter(params) {
    if (params.node.group) {
      // groupping
      return null;
    }
    const { data } = params;
    if (!data) {
      return null;
    }
    const { column } = params.colDef?.cellRendererParams;
    if (!column) {
      return null;
    }
    const { tag } = column;
    const field = trimEnd(tag, 'Percent');
    const value = data[field]?.count || 0;
    const total = data.all?.count || 0;
    if (total > 0) {
      return (value / total) * 100;
    }
    return null;
  }
  
  getColDefs() {
    const { tableColumns } = this.props;
    
    return reduce(tableColumns, (columns, tableColumn) => {
      let column = null;
      if (tableColumn.tag === 'owner') {
        column = this.getSalesRepColumn(tableColumn);
      } else if (tableColumn.tag === 'reminders') {
        column = this.getRemindersColumn(tableColumn);
      } else if (
        tableColumn.tag === 'all' ||
        tableColumn.tag === 'submitted' ||
        tableColumn.tag === 'notSubmitted' ||
        tableColumn.tag === 'qualified' ||
        tableColumn.tag === 'notQualified' || 
        tableColumn.tag === 'excluded'
      ) {
        column = this.getStatColumn(tableColumn);
      } else if (
        tableColumn.tag === 'submittedPercent' ||
        tableColumn.tag === 'notSubmittedPercent' ||
        tableColumn.tag === 'qualifiedPercent' ||
        tableColumn.tag === 'notQualifiedPercent' || 
        tableColumn.tag === 'excludedPercent'
      ) {
        column = this.getStatPercentColumn(tableColumn);
      } else {
        column = {
          column: tableColumn,
          customFieldType: CUSTOM_FIELD_TYPES.USER,
        };
      }
      if (column) {
        columns.push(column);
      }
      return columns;
    }, []);
  }

  getTableControls() {
    const { viewType } = this.state;
    const { progressStats } = this.props;
    const buttons = [
      { id: null, label: 'All' },
      { id: 'won', label: 'Wins' },
      { id: 'lost', label: 'Losses' },
      { id: 'noDecision', label: 'No Decisions' },
    ];

    const comps = [];
    each(buttons, (button) => {
      const stats = values(progressStats[`owners/${button.id || 'all'}`]);
      if (button.id && stats && stats.length) {
        comps.push((
          <Button key={button.id} active={viewType === button.id} onClick={() => { this.onToggleViewType(button.id); }}>
            <span>
              <span className="badge">
                <Counter value={stats.length}>
                  <NumberDisplay value={stats.length} precision={0} />
                </Counter>
              </span>
              {' '}
              {button.label}
            </span>
          </Button>
        ));
      }
    });

    if (comps.length > 0) {
      comps.unshift((
        <Button key="all" active={viewType === null} onClick={() => { this.onToggleViewType(null); }}>
          All
        </Button>
      ));
    }

    return (
      <ButtonGroup>
        {comps}
      </ButtonGroup>
    );
  }

  render() {
    const { fullScreenMode, viewType } = this.state;

    const columnDefs = this.getColDefs();
    
    const allData = this.props.owners || values(this.props.progressStats[`owners/${(viewType || 'all')}`]);

    return (
      <div>
        <GodTable
          id={TABLE_NAME}
          columnDefs={columnDefs}
          rowData={allData}
          onGridReady={this.onGridReady}
          context={{ statUnit: 'Sales Reps' }}
          frameworkComponents={{
            
          }}
          enableFullScreen
          fullScreenMode={fullScreenMode}
          leftControls={this.props.tableControls || this.getTableControls()}
          onExitFullScreen={this.onExitFullScreen}
          onEnterFullScreen={this.onEnterFullScreen}
          tableManageConfigs={{
            enableCustomMeta: true,
            validObjects: ['User'],
            validCustomMetaObjects: ['User'],
          }}
          resourceType={GodTable.RESOURCE_TYPE.USER}
        />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { isAccount } = ownProps;
  const tableColumns = reduce(getTablePreference(state, TABLE_NAME), (items, item) => {
    if (item.tag === 'all') {
      items.push({
        ...item,
        label: isAccount ? 'Total Accounts' : 'Total Opportunities',
      });
    } else {
      items.push(item);
    }
    return items;
  }, []);

  return {
    loadPercentage: getProgressLoadPercentage(state),
    progressStats: getProgressStats(state),
    tableColumns,
  };
}


OwnerTable.propTypes = {
  progressStats: PropTypes.shape({

  }).isRequired,
  tableColumns: PropTypes.arrayOf(PropTypes.shape({})),
  loadPercentage: PropTypes.number,
  isAccount: PropTypes.bool,
  showStats: PropTypes.func,
  onExitFullScreen: PropTypes.func,
  tableControls: PropTypes.node,
  owners: PropTypes.arrayOf(PropTypes.shape({})),
};
OwnerTable.defaultProps = {
  isAccount: false,
  loadPercentage: 0,
  progressStats: {},
  showStats: () => {},
  tableColumns: [],
  onExitFullScreen: () => {},
  tableControls: null,
  owners: null,
};
OwnerTable.contextTypes = {
};

export default connect(mapStateToProps)(OwnerTable);